var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_135_5",
    "data-name": "Component 135 \\u2013 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24329",
    "data-name": "Path 24329",
    d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0Z",
    fill: "none",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44372",
    "data-name": "Group 44372",
    transform: "translate(8.989 13.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44373",
    "data-name": "Group 44373",
    transform: "translate(0.011 0.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88540",
    "data-name": "Path 88540",
    d: "M.75,6.494S4.134.75,10.284.75s9.534,5.744,9.534,5.744",
    transform: "translate(-0.75 -0.75)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_367",
    "data-name": "Ellipse 367",
    cx: 3.417,
    cy: 3.417,
    r: 3.417,
    transform: "translate(6.117 2.328)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.49a5268da8b9d410497062c6b37feb4b.svg";
export { ForwardRef as ReactComponent };